import React from 'react';
import {
  Message,
  Segment,
} from 'semantic-ui-react';

const PaymentWarning = () => (
  <Segment padded>
    <Message
      header="No Payment"
      icon="exclamation"
      content="Just a heads up. The payment for this contract has been skipped. This contract has not been paid for."
      size="large"
      warning
    />
  </Segment>
);

export default PaymentWarning;
